import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';

window.console.log = () => {};
window.console.time = () => {};
window.console.timeEnd = () => {};
window.console.info = () => {};
window.console.debug = () => {};
window.console.warn = () => {};

bootstrapApplication(AppComponent, appConfig)
  .catch((err) => console.error(err));
